function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconVisibleSmallOutline = function IconVisibleSmallOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 14 14"
  }, props, {
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#14x14_visible_outline__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9a2 2 0 100-4 2 2 0 000 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2C4.22 2 1.455 3.552.088 6.59a1 1 0 000 .82C1.455 10.448 4.22 12 7 12c2.78 0 5.545-1.552 6.912-4.59a1 1 0 000-.82C12.545 3.552 9.78 2 7 2zm0 8c-1.895 0-3.805-.982-4.886-3C3.195 4.982 5.104 4 7 4c1.895 0 3.805.982 4.886 3-1.081 2.018-2.99 3-4.886 3z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "14x14_visible_outline__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  }))));
};

export default IconVisibleSmallOutline;